<div class="wf-log-section">
  <div class="wf-log-section-title">Params</div>

  <div *ngIf="!paramsItem?.items?.values.length" class="wf-log-section-empty">
    <p>No params available.</p>
  </div>

  <div *ngIf="paramsItem?.items?.values.length">
    <gs-table
      #wfLogParamsTable
      *ngIf="paramsItem"
      [ngStyle]="{'padding': 5+'px', 'padding-left': 10+'px'}"
      change
      [showPaginator]="false"
      [hideHeaders]="true"
      [wide]="true"
      [readOnly]="true"
      [columns]="paramsColumns"
      [items]="paramsItem.items"
    >
    </gs-table>
  </div>
</div>

<div class="wf-log-section-separator"></div>

<div class="wf-log-section">
  <div class="wf-log-section-title">Log details</div>

  <div *ngIf="!wfLogItem.items?.values.length" class="wf-log-section-empty">
    <p>No log details available.</p>
  </div>

  <div *ngIf="wfLogItem.items?.values.length">
    <gs-table
      #wfLogDetailsTable
      *ngIf="wfLogItem"
      [ngStyle]="{'padding': 5+'px', 'padding-left': 10+'px'}"
      change
      [pageSize]="pageSize"
      (pageSizeChange)="pageSizeChange($event)"
      [totalResultsCnt]="logDetailsCount"
      [showPaginator]="true"
      [wide]="true"
      [readOnly]="true"
      [columns]="columns"
      [items]="wfLogItem.items"
    >
    </gs-table>
  </div>
</div>
